module.exports = __webpack_public_path__ + "static/booklense-894a9323ae60c5a975821ed3b340d8d9.svg";